import { useMediaQuery } from 'react-responsive'
import { BP } from 'resources/constants'

const MD = 1024
const SM = 414

export const useIsMedium = () => {
  return useMediaQuery({ query: `(max-width: ${MD + 1}px)` })
}

export const useIsSmall = () => {
  return useMediaQuery({ query: `(max-width: ${SM + 1}px)` })
}

// TODO: Refactor theme to use these (new) breakpoints
// pulled from theme

export const useIsMd = () => {
  return useMediaQuery({ query: `(max-width: ${BP.lg.max})` })
}

export const useIsSm = () => {
  return useMediaQuery({ query: `(max-width: ${BP.md.max})` })
}

export const useIsXs = () => {
  return useMediaQuery({ query: `(max-width: ${BP.sm.max})` })
}

export const useIsXxS = () => {
  return useMediaQuery({ query: `(max-width: ${BP.xs.max})` })
}

export const useIsMobile = () => {
  return useMediaQuery({ query: `(max-width: ${SM}px)` })
}
